var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMainTabBarCasinoIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon main-tab-bar-casino-icon",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2.4c-5.302 0-9.6 4.298-9.6 9.6s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6-4.298-9.6-9.6-9.6zm0 1.5c4.474 0 8.1 3.626 8.1 8.1s-3.626 8.1-8.1 8.1-8.1-3.626-8.1-8.1S7.526 3.9 12 3.9zM11.997 6c-.94 3.35-4.752 4.374-4.752 7.241 0 1.413.934 2.419 2.353 2.419.79 0 1.672-.392 1.996-1.152 0 .94-.444 2.737-1.067 3.492h2.94c-.622-.755-1.066-2.552-1.066-3.492.323.76 1.206 1.152 1.995 1.152 1.419 0 2.354-1.006 2.354-2.419 0-2.867-3.813-3.89-4.753-7.241z"
  })));
}

export default SvgMainTabBarCasinoIconSv;